
document.addEventListener("DOMContentLoaded", function() {


    /* STOPPING AUTO PLAY
    // Product Carousel Autoplay
    window.addEventListener("resize", function () {
      if (window.matchMedia("(max-width: 767px)").matches) {
        productCarouselAutoplay();
      }
    });

    if (window.matchMedia("(max-width: 767px)").matches) {
      productCarouselAutoplay();
    }

    function productCarouselAutoplay(){
      let intervalDuration = 4000;
      let currentSlideIndex = 0;
      let productCarousel = document.querySelector('scroll-carousel[selector="product-card"]');

      if (!productCarousel) {
        return; // Exit the function if the element doesn't exist
      }

      let interval = setInterval(nextSlide, intervalDuration);
      
      function nextSlide() {
        if((productCarousel.totalPages - 1) == productCarousel.selectedIndex){
          productCarousel.select(0);
        }
        else{
          productCarousel.next();
        }
      }
      

      function resetInterval() {
          clearInterval(interval); 
          interval = setInterval(nextSlide, intervalDuration); 
      }
      
      productCarousel.addEventListener("click", resetInterval);
      productCarousel.addEventListener("touchstart", resetInterval);
      
    }
    // Product Carousel Autoplay END
    */


    // Accordion
    document.querySelectorAll('.accordion-header').forEach(header => {
      header.addEventListener('click', () => {
        const accordionContent = header.nextElementSibling;
        
        header.classList.toggle('active');
    
        if (header.classList.contains('active')) {
          accordionContent.style.display = 'block';
        } else {
          accordionContent.style.display = 'none';
        }
      });
    });
    // Accordion END


  
});

jQuery(function($){
  var mega_menu = $('.mega_menu'),
      mega_menu_item = mega_menu.find('.menu_item'),
      mega_submenu = mega_menu_item.find('.item_submenu');

  let hoverout_time;
  
  /* SCROLL HEADER */
  nav_sticky($('.header'), mega_menu);
  nav_sticky($('.header'), $('.section_menu_list'));

  $(window).on('resize', function(){
    nav_sticky($('.header'), mega_menu);
    nav_sticky($('.header'), $('.section_menu_list'));
  });

  $(window).scroll(function(){
    nav_sticky($('.header'), mega_menu);
    nav_sticky($('.header'), $('.section_menu_list'));
  });

  function nav_sticky($start_elem, $elem_scroll) {
    var start_height = $start_elem.height(),
        start_top = $start_elem[0].getBoundingClientRect().top,
        top = start_height + start_top;

    $elem_scroll.css('top', top + 'px');
  }
  /* SCROLL HEADER */

  /* HOVER SUBMENU DISPLAY */
  mega_menu_item.hover(function(){
    var this_submenu = $(this).find('.item_submenu'),
        other_submenu = mega_submenu.not(this_submenu);
    
    submenu_animate(other_submenu, 'out', hoverout_time);

    if ( this_submenu.length > 0 ) {
      submenu_animate(this_submenu, 'in', hoverout_time);
    }

    mega_menu_item.not($(this)).removeClass('active_menu');
    $(this).addClass('active_menu');
  }, function(){
    var $this = $(this),
        this_submenu = $this.find('.item_submenu');

    if ( this_submenu.length > 0 ) {
      hoverout_time = setTimeout(function() {
        $this.removeClass('active_menu');
        submenu_animate(this_submenu, 'out', hoverout_time);
      }, 300);
    }
  });

  mega_submenu.hover(function(){
    submenu_animate($(this), 'in', hoverout_time);
  }, function(){
    var $this = $(this),
        this_par = $this.parents('.menu_item');

    hoverout_time = setTimeout(function() {
      this_par.removeClass('active_menu');
      submenu_animate($this, 'out', hoverout_time);
    }, 300);
  });
  /* HOVER SUBMENU DISPLAY */

  /* HOVER BANNER CHANGE */
  mega_menu_item.each(function(){
    var mega_banner_change = $(this).find('.col_wrap'),
        mega_subbanner = $(this).find('.submenu_banner'),
        mega_subbanner_img = mega_subbanner.find('img'),
        mega_subbanner_src = mega_subbanner_img.attr('src');

    if ( mega_subbanner !== '' ) {
      mega_banner_change.hover(function(){
        var this_img = $(this).data('banner_img');
        if ( this_img !== '' ) {
          image_change(mega_subbanner_img, this_img);
        }
      }, function(){
        image_change(mega_subbanner_img, mega_subbanner_src);
      });
    }
  });
  /* HOVER BANNER CHANGE */

  /* HOVER TAB */
  let tab_hoverout;

  mega_menu_item.each(function(){
    var mega_tab_title = $(this).find('.tab_title'),
        mega_tab_list = $(this).find('.submenu_list'),
        mega_tab_col = mega_tab_list.find('.submenu_col'),
        mega_tab_banner = mega_tab_list.find('.submenu_banner'),
        mega_tab_banner_img = mega_tab_banner.find('img'),
        mega_tab_banner_src = mega_tab_banner_img.attr('src');

    mega_tab_title.hover(function(){
      var this_siblings = $(this).parent().siblings('.submenu_list'),
          tab_content = $(this).data('tab'),
          tab_content_obj = $('#' + tab_content),
          this_img_src = $(this).data('banner_img'),
          this_banner = this_siblings.find('.submenu_banner'),
          this_banner_img = this_banner.find('img'),
          this_banner_src = this_banner_img.attr('src');

      mega_tab_title.not($(this)).removeClass('active_tab');
      $(this).addClass('active_tab');

      submenu_animate(this_siblings, 'in', tab_hoverout);

      mega_tab_col.not(tab_content_obj).hide();
      submenu_animate(tab_content_obj, 'in');

      if ( this_img_src.length > 0 && this_img_src != this_banner_src ) {
        image_change(mega_tab_banner_img, this_img_src);
      } else if ( this_img_src.length < 1 && this_banner_src != mega_tab_banner_src ) {
        image_change(mega_tab_banner_img, mega_tab_banner_src);
      }
    }, function(){
      var $this = $(this),
          this_siblings = $this.parent().siblings('.submenu_list');

      tab_hoverout = setTimeout(function() {
        $this.removeClass('active_tab');
        submenu_animate(this_siblings, 'out');
        mega_tab_col.hide();
      }, 300);
    });

    mega_tab_list.hover(function(){
      submenu_animate($(this), 'in', tab_hoverout);
    }, function(){
      var $this = $(this),
          this_tab_title = $this.siblings('.submenu_title_tab').find('.tab_title'),
          this_banner = $this.find('.submenu_banner'),
          this_banner_img = this_banner.find('img'),
          this_banner_src = this_banner_img.attr('src');

      tab_hoverout = setTimeout(function() {
        this_tab_title.removeClass('active_tab');
        submenu_animate($this, 'out');
        mega_tab_col.hide();
      }, 300);

      this_tab_title.each(function(){
        var this_tab_img_src = $(this).data('banner_img');

        if ( $(this).hasClass('active_tab') ) {
          if ( this_tab_img_src.length < 1 && this_banner_src != mega_tab_banner_src ) {
            image_change(mega_tab_banner_img, mega_tab_banner_src);
          }
        }
      });
    });
  });
  /* HOVER TAB */

  /* GLOBAL */
  function submenu_animate($elem, $animate, $timeout) {
    if ( $animate == 'in' ) {
      clearTimeout($timeout);
      $elem.stop(true, true).show();
    } else if ( $animate == 'out' ) {
      $elem.stop(true, true).hide();
    }
  }

  function image_change($img, $src) {
    var fade_duration = 100,
        animate_duration = 200;
    $img.stop(true, true).fadeOut(fade_duration, function() {
        $(this).animate({ right: "+=50px" },{
            duration: animate_duration,
            easing: 'linear',
            complete: function(){
              $(this).attr('src', $src).css("right", "-50px").stop(true, true).fadeIn(fade_duration).animate({ right: "0px" }, {
                duration: animate_duration,
                easing: 'linear',
              });
            }
        });
    });
  }
  /* GLOBAL */

  /* WWA SLIDER */
  var wwa_banner_slide = $('.wwa_banner .swiper-container'),
      wwa_banner_wrap = wwa_banner_slide.find('.swiper-wrapper'),
      wwa_banner_item = wwa_banner_slide.find('.swiper-slide'),
      wwa_banner_img_clone = false;
  if ( wwa_banner_slide.length > 0 ) {

    if ( !wwa_banner_img_clone ) {
      wwa_banner_item.each(function(){
        $(this).clone().addClass('clone').appendTo(wwa_banner_wrap);
      });

      wwa_banner_img_clone = true;
    }

    var banner_img_slide = new Swiper(".wwa_banner .swiper-container", {
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 15,
      loop: true,
      breakpoints: {
        // when window width is >= 320px
        700: {
          spaceBetween: 12
        },
      }
    });
    
    $(window).on('load', function(){
      banner_img_slide.slideToLoop(0);
    });
  }
  /* WWA SLIDER */ 

  /* IMAGE STACK */
  if ( $('.stack_img .swiper-container').length > 0 ) {
    var stack_slider = new Swiper(".stack_img .swiper-container", {
      effect: "cards",
      grabCursor: true,
      cardsEffect: {
        perSlideOffset: 1,
        perSlideRotate: 5,
        rotate: true
      },
      loop: true
    });
  }
  /* IMAGE STACK */

  /* PRODUCT INFORMATION OPEN CLOSE */
  $('.product-info-header:not(.product-info-popup-trigger)').click(function () {
    $(this).toggleClass('active');
    const $detail = $(this).next('.product-info-detail');

    if ($detail.is(':visible')) {
      // Close the detail
      $detail
        .css('height', $detail.outerHeight()) // Set current height
        .animate({ height: 0 }, 500, function () {
          $detail.css('height', '').hide(); // Reset height and hide
        });
    } else {
      // Open the detail
      $detail
        .show() // Make it visible
        .css('height', 0) // Start with 0 height
        .animate({ height: $detail.prop('scrollHeight') }, 500, function () {
          $detail.css('height', ''); // Reset height to auto after animation
        });
    }
  });

  $('.btn-more-product-info').click(function() {
    const $detail = $('.product-info-detail');
    // Open the detail
    $detail
      .show() // Make it visible
      .css('height', 0) // Start with 0 height
      .animate({ height: $detail.prop('scrollHeight') }, 500, function () {
        $detail.css('height', ''); // Reset height to auto after animation
      });
  });

  /* PRODUCT INFORMATION POPUP */
  $(document).on('click', '#btn-size-chart', function() {
    $('#product_info_popup_outer').addClass('show');
    console.log('btn clicked');
});

  
  $('.product-info-popup-trigger').click(function(){
    $(this).next('.product-info-popup-outer').addClass('show');
  });

  $('.product-info-popup-outer .btn-close-popup').click(function(){
    $(this).parent().parent().removeClass('show');
  });

  

  $(window).on('scroll', function () {
    var $cta = $('.our-mission-cta a'); // Target the div
    if ($cta.length === 0) {
      return; // Exit if the element doesn't exist
    }
    var windowHeight = $(window).height(); // Height of the viewport
    var scrollTop = $(window).scrollTop(); // Scroll position from top
    var elementOffset = $cta.offset().top; // Distance of the div from top of the document
    var elementHeight = $cta.outerHeight(); // Height of the div
  
    // Check if the middle of the div is in the middle of the viewport
    var elementMiddle = elementOffset + elementHeight / 2;
    var viewportMiddle = scrollTop + windowHeight / 2;
  
    if (Math.abs(viewportMiddle - elementMiddle) <= elementHeight / 2) {
      if (!$cta.hasClass('animate')) {
        $cta.addClass('animate'); // Add class only if not already present
      }
    }
  });



});



$(document).ready(function () {
  function checkAndHideButton() {
    // Get the width of .setpath and .scrollable-list
    var setPathWidth = $('.category-menu .setpath').outerWidth();
    var scrollableListWidth = $('.category-menu .scrollable-list').outerWidth();

    // Hide .circle-button if the width of .setpath is less than or equal to .scrollable-list
    if (setPathWidth <= scrollableListWidth) {
      $('.category-menu .circle-button').css('display', 'none');
    } else {
      $('.category-menu .circle-button').css('display', 'flex');
    }
  }

  // Run the check on page load
  checkAndHideButton();

  // Optionally, rerun the check on window resize if the layout may change
  $(window).resize(function () {
    checkAndHideButton();
  });
});

// FORM CONNECTED WITH KLAVIYO
document.addEventListener('DOMContentLoaded', function () {
    const klaviyoForms = document.querySelectorAll('.klaviyo-form');

    klaviyoForms.forEach((form) => {
        form.addEventListener('submit', function (event) {
            // Always prevent the default form submission
            event.preventDefault();

            const formData = new FormData(form);
            const attributes = { properties: {} };
            const standardAttributes = ["email", "phone_number"];

            // Collect form data
            for (let [key, value] of formData.entries()) {
                if (standardAttributes.includes(key)) {
                    attributes[key] = value;
                } else {
                    attributes.properties[key] = value;
                }
            }

            // Klaviyo API Configuration
            const klaviyoListId = form.getAttribute("data-klaviyo-list-id");
            const options = {
                method: 'POST',
                headers: {
                    'revision': '2023-08-15',
                    'content-type': 'application/json'
                },
                body: JSON.stringify({
                    data: {
                        type: 'subscription',
                        attributes: {
                            custom_source: form.getAttribute("data-name"),
                            profile: {
                                data: {
                                    type: 'profile',
                                    attributes: attributes
                                }
                            }
                        },
                        relationships: { list: { data: { type: 'list', id: klaviyoListId } } }
                    }
                })
            };

            // Ensure only one call to Klaviyo and prevent the warning
            if (!window._learnq) {
                console.error('Klaviyo script not initialized correctly');
                return;
            }

            // Fetch Klaviyo API to submit the form data
            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=TZrt8V', options)
                .then(response => {
                    if (!response.ok) {
                        return response.json().then(err => Promise.reject(err));
                    } else {
                        // On success
                        let customSuccessElement = document.querySelector('.custom-success');

                        $('.leadmagnet-success-message').css({
                            visibility: 'visible'
                        }).animate({ opacity: 1 }, 1000);

                        form.style.display = 'none';

                        if (customSuccessElement) customSuccessElement.style.display = 'block';
                    }
                })
                .catch(err => {
                    console.error('Error sending data to Klaviyo:', err);
                });
        });
    });
});
